import React from 'react';
import BoxCard from '../General/BoxCard';

import {Flex, Heading, Radio, RadioGroup, SimpleGrid} from '@chakra-ui/react';
import {Controller} from 'react-hook-form';
import {SatisfactionOneToTen} from '../../constants/Satisfaction';

const SatisfactionToTen = ({control, question, data, onRadioChange}) => {
  const getDefaultValue = questionId => {
    if (questionId in data) {
      return data[questionId].toString();
    }
    return SatisfactionOneToTen.TEN;
  };
  return (
    <BoxCard>
      <Flex>
        <Heading size="sm" mb="2">
          {question.prompt}
        </Heading>
      </Flex>
      <Flex>
        <Controller
          name={question.id}
          control={control}
          defaultValue={getDefaultValue(question.id)}
          render={({field}) => (
            <RadioGroup {...field} style={{display: 'contents'}} onChange={e => {
              field.onChange(parseInt(e));
              if (onRadioChange) {
                onRadioChange();
              }
            }}>
              <SimpleGrid columns={12} spacing={3}>
                <Heading size="sm">10</Heading>
                <Heading size="sm">9</Heading>
                <Heading size="sm">8</Heading>
                <Heading size="sm">7</Heading>
                <Heading size="sm">6</Heading>
                <Heading size="sm">5</Heading>
                <Heading size="sm">4</Heading>
                <Heading size="sm">3</Heading>
                <Heading size="sm">2</Heading>
                <Heading size="sm">1</Heading>
                <Heading size="sm">0</Heading>
                <Heading size="sm">N/A</Heading>
                <Radio ml="2" colorScheme={'tertiary'} value={SatisfactionOneToTen.TEN} />
                <Radio ml="2" colorScheme={'tertiary'} value={SatisfactionOneToTen.NINE} />
                <Radio ml="2" colorScheme={'tertiary'} value={SatisfactionOneToTen.EIGHT} />
                <Radio ml="2" colorScheme={'tertiary'} value={SatisfactionOneToTen.SEVEN} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.SIX} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.FIVE} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.FOUR} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.THREE} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.TWO} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.ONE} />
                <Radio ml="2" colorScheme={'red'} value={SatisfactionOneToTen.ZERO} />
                <Radio ml="2" colorScheme={'tertiary'} value={SatisfactionOneToTen.NA} />
              </SimpleGrid>
            </RadioGroup>
          )}
        />
      </Flex>
    </BoxCard>
  );
};

export default SatisfactionToTen;
